import { mergeProps, splitProps } from "solid-js";
import { Dynamic } from "solid-js/web";
import FormContext from "./FormContext";
const defaultProps = {
    as: "div",
};
const FormGroup = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), ["as", "controlId"]);
    const context = {
        get controlId() {
            return local.controlId;
        },
    };
    return (<FormContext.Provider value={context}>
      <Dynamic component={local.as} {...props}/>
    </FormContext.Provider>);
};
export default FormGroup;
